import { PersonaImageAvatar } from "@/components/PersonaImageAvatar.tsx";
import { PropsWithChildren, useEffect, useRef } from "react";

export function PersonaHeader({
  videoSrc,
  imageSrc,
  name,
  gender,
  children,
}: PropsWithChildren<{
  videoSrc?: string;
  imageSrc?: string;
  name: string;
  gender?: "male" | "female";
}>) {
  const videoRef = useRef<HTMLVideoElement | null>(null);

  useEffect(() => {
    videoRef.current?.load();
    const video = videoRef.current;
    if (video) {
      const handleVideoEnd = () => {
        setTimeout(() => {
          if (video.paused) {
            video.play().catch((e) => console.error("Error playing video:", e));
          }
        }, 3000);
      };

      video.addEventListener("ended", handleVideoEnd);

      return () => {
        if (video) {
          video.removeEventListener("ended", handleVideoEnd);
        }
      };
    }
  }, [videoSrc]);

  return (
    <div className="w-full flex flex-col items-center mt-4">
      <div className="relative w-32 aspect-square">
        {videoSrc ? (
          <video
            className="w-32 h-32 object-cover rounded-full border-2 border-solid border-[#D1FA64]"
            ref={videoRef}
            loop
            autoPlay
            muted
          >
            <source src={videoSrc} type="video/mp4" />
          </video>
        ) : (
          <PersonaImageAvatar
            className="w-32 h-32 rounded-full border-2 border-solid border-[#D1FA64]"
            src={imageSrc}
            altText={`${name ? `${name}'s ` : ""}Avatar"`}
            gender={gender}
          />
        )}
      </div>
      {children}
    </div>
  );
}
